import React from "react";
import { Button } from "./ui/button";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center cherishlink-gradient-bg p-6">
        <div className="text-center max-w-md" data-testid="error-boundary">
          <div className="h-14 w-14 rounded-2xl bg-amber-100 grid place-items-center mx-auto">
            <AlertTriangle className="h-6 w-6 text-amber-700" />
          </div>
          <h1 className="mt-6 font-display text-2xl font-bold tracking-tight">Something went sideways.</h1>
          <p className="mt-2 text-muted-foreground text-sm">
            We hit an unexpected error. Reloading usually helps. If it keeps happening, please let us know.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Button onClick={() => window.location.reload()} className="rounded-full" data-testid="error-reload">
              Reload
            </Button>
            <Button variant="outline" className="rounded-full" onClick={() => { window.location.href = "/"; }}>
              Back to home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
